import { render, staticRenderFns } from "./dangerJournal.vue?vue&type=template&id=768cc7e4"
import script from "./dangerJournal.vue?vue&type=script&lang=js"
export * from "./dangerJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768cc7e4')) {
      api.createRecord('768cc7e4', component.options)
    } else {
      api.reload('768cc7e4', component.options)
    }
    module.hot.accept("./dangerJournal.vue?vue&type=template&id=768cc7e4", function () {
      api.rerender('768cc7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerJournal.vue"
export default component.exports